
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSwitch, AppAvatarBreadcrumb } from '@/components';
import { useAvatarItemEdit } from '@/modules/avatar/item/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.ITEM.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSwitch, AppAvatarBreadcrumb },
    setup() {
        const { model, v$, fetch, actions } = useAvatarItemEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, ROUTE_NAME_AVATAR };
    }
});
